<template>
  <div v-if="store.borrowerWebContent">
    <div
      class="white"
    >
      <v-container class="pt-0">
        <v-layout
          row
          wrap
        >
          <v-flex
            id="topSpacer"
            xs12
            class="mt-5 hidden-sm-and-down"
          >
            &nbsp;
          </v-flex>
          <v-flex
            xs12
            sm7
            :md5="showApp"
            :xs3="!showApp"
            :offset-xs3="!showApp"
            :justify-center="!showApp"
          >
            <div v-if="store.servicer !== null && store.borrowerWebContent !== null">
              <h1
                v-if="store.borrowerWebContent"
                :class="{'mt-6 display-2': $vuetify.breakpoint.mdAndUp, 'display-1': $vuetify.breakpoint.smAndDown }"
                class="light accent--text"
              >
                {{ store.borrowerWebContent.splashHeader }}
              </h1>
              <v-flex
                xs12
                :md10="showApp"
                :md12="!showApp"
              >
                <h2
                  v-if="store.borrowerWebContent"
                  class="mt-4 subheading light accent--text"
                >
                  {{ store.borrowerWebContent.splashSubheader }}
                </h2>
                <div
                  class="mt-4 mb-3"
                >
                  <v-layout
                    v-if="store.borrowerWebContent && store.servicer && store.servicer.has_1003_enhanced === true"
                    :class="{'wrap': $vuetify.breakpoint.smAndDown, 'justify-center': $vuetify.breakpoint.lgAndDown }"
                    row
                    wrap
                  >
                    <template
                      v-if="store.borrowerWebContent.splashLoanButtonChoices.length > 2"
                    >
                      <v-flex
                        v-for="(button, index) in store.borrowerWebContent.splashLoanButtonChoices"
                        :key="button + 'signup-' + index"
                        style="flex: 0 1 auto"
                      >
                        <v-btn
                          :aria-label="Object.keys(button)[0]"
                          dark
                          class="btn--xlarge text--white ml-0"
                          color="primary"
                          @click.native="setLoanPurpose(Object.values(button)[0]);goToBorrowerOnboarding()"
                        >
                          {{ Object.keys(button)[0] }}
                        </v-btn>
                      </v-flex>
                    </template>
                    <template
                      v-else-if="store.borrowerWebContent.splashLoanButtonChoices.length <= 2"
                    >
                      <v-flex
                        v-for="(button, index) in store.borrowerWebContent.splashLoanButtonChoices"
                        :key="button + index"
                        class="text-xs-center"
                        xs12
                        md6
                      >
                        <v-btn
                          :aria-label="Object.keys(button)[0]"
                          class="btn--xlarge btn--block primary text--white mx-auto"
                          style="min-width: 160px;"
                          dark
                          x-large
                          @click.native="setLoanPurpose(Object.values(button)[0]);goToBorrowerOnboarding()"
                        >
                          {{ Object.keys(button)[0] }}
                        </v-btn>
                      </v-flex>
                    </template>
                  </v-layout>
                  <v-layout
                    :class="{'wrap': $vuetify.breakpoint.smAndDown}"
                    row
                  >
                    <template
                      v-if="store.borrowerWebContent && store.servicer && store.servicer.has_1003_enhanced !== true && (store.servicer.allow_borrower_web_signup === true || isMobileShareSignup)"
                    >
                      <v-btn
                        :class="{'btn--block': $vuetify.breakpoint.smAndDown}"
                        aria-label="create account"
                        dark
                        class="btn--block ml-0 pl-5 pr-5 btn--xlarge primary text--white"
                        @click.native="store.loanPurpose='skipLoanApp';goToBorrowerOnboarding()"
                      >
                        {{ store.borrowerWebContent.splashNo1003Button }}
                      </v-btn>
                    </template>
                  </v-layout>
                </div>
                <v-layout
                  v-if="store.servicer && store.servicer.has_1003_enhanced === true"
                  row
                >
                  <v-flex xs12>
                    <p
                      class="body-1 mt-3 pl-0 ml-0 grey--text text--darken-1 hoverable subheading font-weight-bold text-uppercase text-xs-center text-md-left"
                      @click="store.loanPurpose='skipLoanApp';goToBorrowerOnboarding()"
                    >
                      {{ store.borrowerWebContent.splashAlternateActionLinkText }}
                    </p>
                  </v-flex>
                </v-layout>
              </v-flex>
            </div>
          </v-flex>
          <v-flex
            v-if="showApp"
            class="mx-2 hidden-md-and-down"
          >
            &nbsp;
          </v-flex>
          <v-flex
            v-if="showApp"
            sm5
            md6
            class="hidden-sm-and-down ml-6 mt-0 mb-6"
          >
            <app-preview />
          </v-flex>
        </v-layout>

        <v-flex class="my-1 hidden-sm-and-down">
&nbsp;
        </v-flex>

        <hr :class="{'mb-6': $vuetify.breakpoint.mdAndUp, 'mt-3 mb-5': $vuetify.breakpoint.smAndDown}">

        <template
          v-if="showApp"
        >
          <mobile-info />
          <hr
            :class="{'mt-5': $vuetify.breakpoint.mdAndUp, 'mb-5': $vuetify.breakpoint.smAndDown}"
          >
        </template>

        <v-flex
          id="contactInfo"
          md6
          offset-md3
          xs10
          offset-xs1
        >
          <contact-info />
        </v-flex>
        <v-layout
          v-if="store.servicer"
          row
        >
          <borrower-footer />
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import snUtilService from '../../services/snUtilService.js'
import snValidationsService from '../../services/snValidationsService.js'
import appPreview from './_appPreview.vue'
import borrowerFooter from './_borrowerFooter.vue'
import contactInfo from './_contactInfo.vue'
import mobileInfo from './_mobileInfo.vue'

export default {
  name: 'BorrowerInitial',
  components: {
    'app-preview': appPreview,
    'borrower-footer': borrowerFooter,
    'contact-info': contactInfo,
    'mobile-info': mobileInfo
  },
  filters: {
  },
  data () {
    return {
      errors: {
        'newUser.firstName': [],
        'newUser.lastName': [],
        'newUser.email': [],
        'newUser.phone': [],
        'newUser.password': [],
        'newUser.passwordConfirmation': []
      },
      errorsFromServer: [],
      newUser: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        password: null,
        passwordConfirmation: null,
        account_type: 'app_user'
      },
      sendToMobileNumber: null,
      store: this.$store
    }
  },
  computed: {
    showApp () {
      return this.store?.borrowerWebContent?.showMobileContentOnLandingPage || !!(this?.$route?.query?.from_mobile_share === 'true' && this.store?.servicer?.feature_setting_force_mobile_web_signup_from_sharelink_enabled)
    }
  },
  beforeUpdate () {
    this.$store.sidenav = false
  },
  created () {
    if (this.$route && this.$route.query.email) {
      this.$router.push({ path: '/borrower/onboarding/' + this.store.activationCode + '?email=' + encodeURIComponent(this.$route.query.email) })
    }
  },
  methods: {
    setLoanPurpose (purpose) {
      sessionStorage.setItem('loanPurpose', purpose)
    },
    goToBorrowerOnboarding () {
      this.$router.push({ path: this.$options.filters.onboardingRoute(this.$route, this.store.activationCode) })
    },
    goToNextStep () {
      if (this.store.servicer.has_1003_enhanced === true && this.store.loanPurpose !== 'skipLoanApp') {
        this.$router.push({ path: '/borrower/custom_form?type=loan_app' })
      } else {
        this.$router.push({ path: '/borrower/dashboard' })
      }
    },
    passwordValid () {
      var pw = this.newUser.password
      if (pw === null || pw === '' || pw.length < 9 || !/(?=.*[a-z])/.test(pw) || !/(?=.*[A-Z])/.test(pw) || !/(?=.*[0-9])/.test(pw)) {
        return false
      } else {
        return true
      }
    },
    removeValidationErrors (key) {
      this.$set(this.errors, key, [])
    },
    shareAppBySms () {
      var that = this
      this.$snackbard.loading({ text: 'Sending text message.' })
      snUtilService.shareAppBySms(that.sendToMobileNumber, that.$route.query.code)
        .then(response => {
          that.sendToMobileNumber = null
          this.$snackbard.cancel({ text: 'Message sent.' })
        })
        .catch(e => {
          this.$sentry.captureException(e)
          that.errors.push(e)
        })
    },
    validatePassword () {
      if (!this.passwordValid()) {
        this.$set(this.errors, 'newUser.password', 'Password must have at least 9 characters, one uppercase letter, one lowercase letter, and one number')
      } else {
        this.$set(this.errors, 'newUser.password', [])
      }
    },
    validatePasswordConfirmation () {
      if (!this.passwordValid() || this.newUser.passwordConfirmation === null || this.newUser.passwordConfirmation === '' || this.newUser.password !== this.newUser.passwordConfirmation) {
        this.$set(this.errors, 'newUser.passwordConfirmation', 'Password confirmation is required and must match valid password field.')
      } else {
        this.$set(this.errors, 'newUser.passwordConfirmation', [])
      }
    },
    validatePhone (phone) {
      if (snValidationsService.phone(phone)) {
        this.$set(this.errors, 'newUser.phone', [])
      } else if (phone === null || phone === '') {
        this.$set(this.errors, 'newUser.phone', 'This is a required field.')
      } else {
        this.$set(this.errors, 'newUser.phone', 'Invalid phone number.')
      }
    }
  }
}
</script>

<style scoped>
  .iphone_mock {
    color: #888;
    height:420px;
    line-height:20px;
    margin-top:200px;
    margin-left:30px;
    position:absolute;
    z-index:2;
  }
  .web_chrome {
    height:50px;
  }
  .web_circle {
    border-radius: 10px;
    display: inline-block;
    height: 10px;
    margin-top: 20px;
    margin-left: 3px;
    width: 10px;
    background-color: #DDDDDD;
  }
  .web_circle:first-of-type {
    margin-left: 15px;
  }
  .web_bar {
    height: 15px;
  }
  .web_image {
    height: 160px;
    width: 100%;
    background-color: #eee;
    background-image: url("../../assets/images/houseimage.png");
  }
  .web_image h5 {
    padding-top:70px;
  }
  .web_mock {
    border:1px solid #ddd;
    border-radius: 5px;
    width:490px;
    height:550px;
    left:110px;
    position:relative;
    -webkit-box-shadow: 0px 7px 34px 2px rgba(219,216,219,1);
    -moz-box-shadow: 0px 7px 34px 2px rgba(219,216,219,1);
    box-shadow: 0px 7px 34px 2px rgba(219,216,219,1);
    z-index:0;
  }

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .web_list.left {
      float: none !important;
    }
  }
</style>
